export const RULE_TYPES = [
  {
    id: 'HREF',
    name: 'HREF'
  },
  {
    id: 'IMG',
    name: 'Image Filename'
  },
  {
    id: 'JS',
    name: 'Javascript Filename'
  },
  {
    id: 'CSS',
    name: 'Style Sheet Filename'
  },
  {
    id: 'JS Content',
    name: 'Javascript Content'
  },
  {
    id: 'CSS Content',
    name: 'Style Sheet Content'
  },
  {
    id: 'IFRAME Content',
    name: 'Iframe Content'
  }
];

export const RULE_ACTIONS = [
  {
    id: 'Do not monitor',
    name: 'Do Not Monitor'
  },
  {
    id: 'Monitor',
    name: 'Monitor'
  }
];

export const RULE_CONDITIONS = [
  {
    id: 'Contains',
    name: 'Contains'
  },
  {
    id: 'Does not contain',
    name: 'Does not contain'
  },
  {
    id: 'Begins with',
    name: 'Begins With'
  },
  {
    id: 'Ends with',
    name: 'Ends With'
  },
  {
    id: 'Equals to',
    name: 'Equals To'
  }
];

/** Integrity result element names mapped to policy API rule type IDs. */
const INTEGRITY_ELEMENT_TYPE_TO_POLICY_TYPE = {
  href: 'HREF',
  img: 'IMG',
  script: 'JS',
  css: 'CSS'
};

/**
 * Maps integrity-engine element_type strings to policy form type ids (HREF, IMG, JS, …).
 * Returns null for elements that cannot be represented as a policy rule.
 */
export function mapIntegrityElementTypeToPolicyRuleType(elementType) {
  const raw = String(elementType ?? '').trim();
  if (!raw) return null;
  const lower = raw.toLowerCase();
  return INTEGRITY_ELEMENT_TYPE_TO_POLICY_TYPE[lower] || null;
}

/** Returns the user-facing label for a canonical policy rule type ID. */
export function getRuleTypeDisplayName(typeId) {
  const row = RULE_TYPES.find((t) => t.id === typeId);
  return row ? row.name : typeId;
}

/** Returns the user-facing label for a policy rule condition ID. */
export function getRuleConditionDisplayName(conditionId) {
  const row = RULE_CONDITIONS.find((c) => c.id === conditionId);
  return row ? row.name : conditionId;
}

/** Returns the user-facing label for a policy rule action ID. */
export function getRuleActionDisplayName(actionId) {
  const row = RULE_ACTIONS.find((a) => a.id === actionId);
  return row ? row.name : actionId;
}
